import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { audienceQuerySchema } from './audience-query-schema';

export const audienceFormSchema = audienceQuerySchema
  .omit({ name: true, status: true, plural: true, clients_count: true })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    plural: z.string(),
  });
export type AudienceFormSchema = z.infer<typeof audienceFormSchema>;
